import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-timeout-warning',
  templateUrl: './timeout-warning.component.html',
  styleUrls: ['./timeout-warning.component.css']
})
export class TimeoutWarningComponent {
  @Input() onExtend: () => void = () => {};
  @Input() onLogout: () => void = () => {};

  extend() : void {
    this.onExtend();
  }

  logout() {
    this.onLogout();
  }
}
